import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateFaxContacts = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 350.83 345.76",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: ".c,.d,.e{fill:none;}.c,.f,.g,.h,.i,.j,.k,.l,.m{stroke-width:0px;}.d{stroke:#3f8bfd;stroke-width:7px;}.d,.e{stroke-linecap:round;stroke-miterlimit:3;}.n{clip-path:url(#b);}.e{stroke:#dcebfe;stroke-width:4.85px;}.f{fill:#3f8bfd;}.g{fill:#c2f4f1;}.h{fill:#dcebfe;}.i{fill:#9ec5ff;}.j{fill:#fff;}.k{fill:#ffc700;}.l{fill:#ebf3ff;}.m{fill:#002f75;}" }), /* @__PURE__ */ _jsx("clipPath", {
			id: "b",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "c",
				cx: 188.63,
				cy: 145.92,
				r: 55
			})
		})] }),
		/* @__PURE__ */ _jsx("circle", {
			className: "l",
			cx: 163.72,
			cy: 183.26,
			r: 162.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "f",
			x: 128.24,
			y: 82.88,
			width: 178.56,
			height: 228.77,
			rx: 20.02,
			ry: 20.02,
			transform: "translate(79.37 -61.85) rotate(19.73)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "g",
			x: 124.02,
			y: 77.46,
			width: 177.49,
			height: 227.4,
			rx: 19.9,
			ry: 19.9,
			transform: "translate(47.82 -42.52) rotate(12.85)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "i",
			x: 28.15,
			y: 76.26,
			width: 177.49,
			height: 227.4,
			rx: 19.9,
			ry: 19.9,
			transform: "translate(-29.69 21.84) rotate(-9.48)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "c",
			x: 76.32,
			y: 63.34,
			width: 193.34,
			height: 237.6,
			rx: 16.68,
			ry: 16.68,
			transform: "translate(-8.05 8) rotate(-2.59)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "m",
			d: "M264.57,112.13h6.6c4.83,0,8.74,3.92,8.74,8.74v123.59c0,4.83-3.92,8.74-8.74,8.74h-6.6V112.13h0Z",
			transform: "translate(20.59 -27.46) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "f",
			d: "M266.42,112.23h6.6c4.83,0,8.74,3.92,8.74,8.74v88.32c0,4.83-3.92,8.74-8.74,8.74h-6.6v-105.81h0Z",
			transform: "translate(18.76 -27.75) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "i",
			d: "M268.26,112.33h6.6c4.83,0,8.74,3.92,8.74,8.74v53.05c0,4.83-3.92,8.74-8.74,8.74h-6.6v-70.54h0Z",
			transform: "translate(16.94 -28.03) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "j",
			x: 86.27,
			y: 57.96,
			width: 178.83,
			height: 229.13,
			rx: 24.1,
			ry: 24.1,
			transform: "translate(19 -17.42) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "h",
			d: "M98.49,279.61l.26.03c-13.24-1.39-22.84-13.25-21.45-26.49l18.91-179.93c1.39-13.24,13.25-22.84,26.49-21.45l-.26-.03-23.95,227.87Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "n",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					className: "h",
					cx: 188.63,
					cy: 145.92,
					r: 55
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "i",
					cx: 189.91,
					cy: 133.68,
					r: 22.04
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "i",
					cx: 183.87,
					cy: 191.13,
					r: 38.47
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "c",
					cx: 183.87,
					cy: 191.13,
					r: 38.47
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "k",
			d: "M270.1,112.42h6.6c4.83,0,8.74,3.92,8.74,8.74v17.78c0,4.83-3.92,8.74-8.74,8.74h-6.6v-35.27h0Z",
			transform: "translate(15.12 -28.32) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 81.27,
			y1: 92.25,
			x2: 106.13,
			y2: 94.87
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 78.34,
			y1: 120.09,
			x2: 103.21,
			y2: 122.7
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 75.42,
			y1: 147.92,
			x2: 100.28,
			y2: 150.53
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 72.49,
			y1: 175.75,
			x2: 97.36,
			y2: 178.36
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 69.57,
			y1: 203.58,
			x2: 94.43,
			y2: 206.2
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "d",
			x1: 66.64,
			y1: 231.41,
			x2: 91.51,
			y2: 234.03
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "e",
			x: 125.41,
			y: 225.05,
			width: 107.83,
			height: 18.7,
			rx: 6.5,
			ry: 6.5,
			transform: "translate(25.48 -17.46) rotate(6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "i",
			cx: 342.47,
			cy: 203.05,
			r: 8.35
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "i",
			cx: 129.05,
			cy: 7,
			r: 7
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "h",
			cx: 7,
			cy: 231.9,
			r: 7
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "h",
			cx: 232.91,
			cy: 32.32,
			r: 12.5
		})
	]
});
export default SvgEmptyStateFaxContacts;
